module.exports = __webpack_public_path__ + "static/media/Facebook.ccdc4020.svg";